import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Info = (props: IconProps) => (
  <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24Z" />
    <path
      d="M10.7 17C10.7 17.718 11.282 18.3 12 18.3C12.718 18.3 13.3 17.718 13.3 17V10.4027C13.3 9.68477 12.718 9.10274 12 9.10274C11.282 9.10274 10.7 9.68477 10.7 10.4027V17ZM10.7 6.99452C10.7 7.7116 11.2872 8.28904 12 8.28904C12.7128 8.28904 13.3 7.7116 13.3 6.99452C13.3 6.27744 12.7128 5.7 12 5.7C11.2872 5.7 10.7 6.27744 10.7 6.99452Z"
      fill="white"
      stroke="black"
      strokeWidth="0.6"
    />
  </Icon>
);
